/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import HeroSection from "../sections/HeroSection";
import AboutSection from "../sections/AboutSection";
import MisionSection from "../sections/MisionSection";
import ServiciosSection from "../sections/ServiciosSection";
import VideoSection from "../sections/VideoSection";
import ClientesSection from "../sections/ClientesSection";
import ContactoSection from "../sections/ContactoSection";
import UbicacionSection from "../sections/UbicacionSection";
import EquiposSection from "../sections/EquiposSection";
import WhatsAppButton from "../components/WhatsAppButton";

export default function Home() {
  return (
    <>
      <HeroSection />
      <AboutSection />
      <MisionSection />
      <VideoSection />
      <ServiciosSection />
      <EquiposSection />
      <ClientesSection />
      <ContactoSection />
      <UbicacionSection />
      <WhatsAppButton />
    </>
  );
}
